//정기식 지점별 주문/취소 마감 설정 공용 유틸
//서버 mysetting 응답의 deadlines 필드와 동일 구조 (null이면 미설정 지점 - 기존 하드코딩 동작 유지)

export type RegularMealDeadline = { daysBefore: number, time: string };

export type RegularMealDeadlines = {
    orderLunch: RegularMealDeadline,
    orderDinner: RegularMealDeadline,
    cancelLunch: RegularMealDeadline,
    cancelDinner: RegularMealDeadline
};

//마감 시각 계산: 대상 날짜 기준 daysBefore일 전 time(HH:MM) - 서버와 동일 공식
export const makeDeadlineCutoff = (targetDate: Date, deadline: RegularMealDeadline): Date => {
    const timeParts = deadline.time.split(":");
    return new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate() - deadline.daysBefore, +timeParts[0], +timeParts[1], 0, 0);
}

//지금 기준 마감 지났는지 (now >= cutoff)
export const isDeadlinePassed = (targetDate: Date, deadline: RegularMealDeadline): boolean => {
    return new Date().getTime() >= makeDeadlineCutoff(targetDate, deadline).getTime();
}

//안내문구용: "당일 10:00" / "1일 전 18:00" / "2일 전 23:00"
export const deadlineToString = (deadline: RegularMealDeadline): string => {
    const dayString = deadline.daysBefore === 0 ? "당일" : `${deadline.daysBefore}일 전`;
    return `${dayString} ${deadline.time}`;
}
